import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'


@Component({
	selector: 'epic-table-cell',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './table-cell.component.html',
	styleUrls: ['./table-cell.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableCellComponent {
	@Input() text?: string
}
